<template lang="pug">
	.preview-genre-add(v-show="showed" :style="position" v-pseudo-modal-name="'preview-genre-add'")
		MultiLevelDropdownMenu(ref="dropdownMenu" @change="addEvent($event.item, $event.data)")
</template>

<script>
	import Screen from './../../mixins/screen'

	import MultiLevelDropdownMenu from './../UI/MultiLevelDropdownMenu'

	export default {
		name: 'PreviewGenreAdd',
		mixins: [Screen],
		screen: {
			updateOn: [

			],
			events: {
				"Show PreviewGenreAdd": function(el, preview) {

					this.preview = preview;

					let rect = el.getBoundingClientRect();

					this.position.right = (document.body.clientWidth - rect.right) + 'px';
					this.position.bottom = (document.body.clientHeight - rect.bottom) + 'px';

					this.update();

				},
				// Клик в любом месте кроме контента помеченного preview-genre-add - закрывает компонент
				"Pseudo Modal Process Hide": function(names) {

					if (!_.includes(names, 'preview-genre-add') && this.showed) {

						this.close();

					}

				}
			}
		},
		components: {
			MultiLevelDropdownMenu
		},
		props: [],
		data() {

			this.preview = null;

			return {
				position: {
					right: 0,
					bottom: 0
				}
			};

		},
		methods: {
			collectData() {

				if (!this.preview) return;

				let categoryItemsTree = _.map(_.orderBy(_.filter(Metadata.GenreCategories, category => category.active), "priority"), category => {return {title: category.title, codename: category.codename, childs: _.map(_.orderBy(_.filter(Metadata.Genres, genreProps => genreProps["category_codename"] === category.codename && genreProps.active), 'priority'), genreProps => {
						return {..._.pick(genreProps, ['title']), width: 200, disabled: this.preview.Genres?.[genreProps.codename], data: {genreCodename: genreProps.codename}}
				})}});

				categoryItemsTree.push({title: "Technology", width: 200, childs: _.map(_.orderBy(_.filter(Metadata.Genres, genreProps => genreProps["category_codename"] === "" && genreProps.active), 'priority'), genreProps => {
					return {..._.pick(genreProps, ['title']), width: 200, disabled: this.preview.Genres?.[genreProps.codename], data: {genreCodename: genreProps.codename}}
				})});

				if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.setItems(categoryItemsTree);

			},
			addEvent(item, data = {}) {

				Server.sendToSocket({
					AddPreviewGenre: {
						previewId: this.preview.id,
						genreCodename: data.genreCodename
					}
				});

				this.close();

			},
			close() {

				if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.close();

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.preview-genre-add
		position: absolute
		user-select: none

</style>
